import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { onMounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { useDictionary } from '@/store/dictionary.store';
import { TableColumn } from '@/components/GbTables/GbTablesTypes';
import { StampUseLogApi } from '@/apis/basics/stamps.api';
import moment from 'moment';
// 添加多语言支持
import { useLocales } from '@/hooks/useLocales';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useLocales();

const state = reactive({
	loading: false,
	queryParams: {} as any,
	pagedParams: { page_size: 10, current: 1 } as any,
});

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<any>({
	getListApi: StampUseLogApi,
	response: { data: 'data', total: 'total' },
});

const { push } = useRouter();
const { getName } = useDictionary();
const { setSearchParams } = methods;

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
	{ field: 'stamp_type', label: t('stampuse.table.stampType', '印章分类'), columnWidth: '80', align: 'center' },
	{ field: 'stamp_no', label: t('stampuse.table.stampNo', '印章编号'), columnWidth: '120', headerAlign: 'left' },
	{ field: 'stamp_name', label: t('stampuse.table.stampName', '印章名称'), columnWidth: '150', headerAlign: 'left' },
	{ field: 'no', label: t('contract.no', '合同编号'), columnWidth: '130', headerAlign: 'left' },
	{ field: 'name', label: t('contract.name', '合同名称'), headerAlign: 'left' },
	{ field: 'contract_amount', label: t('stampuse.table.contractAmount', '合同金额'), headerAlign: 'center', align: 'right', columnWidth: '100' },
	{ field: 'create_user_name', label: t('stampuse.table.applicant', '申请人'), align: 'center', columnWidth: '80' },
	{ field: 'is_sure', label: t('stampuse.table.status', '状态'), width: '100', align: 'center' },
	{ field: 'action_time', label: t('stampuse.table.confirmTime', '确认时间'), columnWidth: '120', fixed: 'right', align: 'center' },
	{ field: 'created_time', label: t('stampuse.table.createdDate', '创建日期'), columnWidth: '120', fixed: 'right', align: 'center' },
	{ field: 'action', width: '120px', label: t('contractList.table.action', '操作'), fixed: 'right', align: 'center' },
]);

const actions = {
	onSearch: () => {
		const search = Object.assign(state.queryParams, state.pagedParams);
		setSearchParams(search);
	},
	reSet: () => {
		state.queryParams = {};
		const search = Object.assign(state.queryParams, state.pagedParams);
		setSearchParams(search);
	},
	showDetail: (row: any) => {
		push({ path: `/contracts/previews`, query: { contractId: `${row.contract_id}` } });
	},
	comfirm: (row: any) => {
		push(`/contract/audit?contractId=${row.contract_id}`);
	},
};

onMounted(() => {
	const search = Object.assign(state.queryParams, state.pagedParams);
	setSearchParams(search);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          size: "small",
          model: _unref(state).queryParams,
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('contract.no', '合同编号')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).queryParams.no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).queryParams.no) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('contract.name', '合同名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).queryParams.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).queryParams.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('stampuse.form.stampNo', '印章编号')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).queryParams.stamp_no,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).queryParams.stamp_no) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('stampuse.form.stampName', '印章名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).queryParams.stamp_name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).queryParams.stamp_name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, { "label-width": '80px' }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _unref(state).queryParams.is_sure,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(state).queryParams.is_sure) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_button, { label: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('stampuse.status.all', '全部')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, { label: "N" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('stampuse.status.pending', '待确认')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, { label: "Y" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('stampuse.status.confirmed', '已确认')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: actions.onSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.search', '查询')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      onClick: actions.reSet
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.cancel', '重置')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"},
      disabled: _unref(tableObject).loading
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          contract_amount: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.contract_amount.toLocaleString('zh')), 1)
          ]),
          is_sure: _withCtx(({ row }) => [
            (row.is_sure == 'Y')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "success",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('stampuse.status.confirmed', '已确认')), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "warning",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('stampuse.status.pending', '待确认')), 1)
                  ]),
                  _: 1
                }))
          ]),
          stamp_type: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, {
              type: "info",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getName)('stamp_type', row.stamp_type)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          action_time: _withCtx(({ row }) => [
            (row.action_time)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(moment)(row.action_time).format('YYYY-MM-DD HH:mm')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, " -- "))
          ]),
          created_time: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY-MM-DD HH:mm')), 1)
          ]),
          action: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "info",
              link: "",
              onClick: ($event: any) => (actions.showDetail(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('buttons.preview', '详细')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (row.can_sure)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "warning",
                  link: "",
                  onClick: ($event: any) => (actions.comfirm(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('stampuse.buttons.confirm', '确认')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }, 8, ["disabled"])
  ], 64))
}
}

})